function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getEventCoordinates } from '@dnd-kit/utilities';
function createSnapModifier(gridSize) {
  return function (_ref) {
    var transform = _ref.transform;
    return _objectSpread(_objectSpread({}, transform), {}, {
      x: Math.ceil(transform.x / gridSize) * gridSize,
      y: Math.ceil(transform.y / gridSize) * gridSize
    });
  };
}
var restrictToHorizontalAxis = function restrictToHorizontalAxis(_ref) {
  var transform = _ref.transform;
  return _objectSpread(_objectSpread({}, transform), {}, {
    y: 0
  });
};
function restrictToBoundingRect(transform, rect, boundingRect) {
  var value = _objectSpread({}, transform);
  if (rect.top + transform.y <= boundingRect.top) {
    value.y = boundingRect.top - rect.top;
  } else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) {
    value.y = boundingRect.top + boundingRect.height - rect.bottom;
  }
  if (rect.left + transform.x <= boundingRect.left) {
    value.x = boundingRect.left - rect.left;
  } else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) {
    value.x = boundingRect.left + boundingRect.width - rect.right;
  }
  return value;
}
var restrictToParentElement = function restrictToParentElement(_ref) {
  var containerNodeRect = _ref.containerNodeRect,
    draggingNodeRect = _ref.draggingNodeRect,
    transform = _ref.transform;
  if (!draggingNodeRect || !containerNodeRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
var restrictToFirstScrollableAncestor = function restrictToFirstScrollableAncestor(_ref) {
  var draggingNodeRect = _ref.draggingNodeRect,
    transform = _ref.transform,
    scrollableAncestorRects = _ref.scrollableAncestorRects;
  var firstScrollableAncestorRect = scrollableAncestorRects[0];
  if (!draggingNodeRect || !firstScrollableAncestorRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
var restrictToVerticalAxis = function restrictToVerticalAxis(_ref) {
  var transform = _ref.transform;
  return _objectSpread(_objectSpread({}, transform), {}, {
    x: 0
  });
};
var restrictToWindowEdges = function restrictToWindowEdges(_ref) {
  var transform = _ref.transform,
    draggingNodeRect = _ref.draggingNodeRect,
    windowRect = _ref.windowRect;
  if (!draggingNodeRect || !windowRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
var snapCenterToCursor = function snapCenterToCursor(_ref) {
  var activatorEvent = _ref.activatorEvent,
    draggingNodeRect = _ref.draggingNodeRect,
    transform = _ref.transform;
  if (draggingNodeRect && activatorEvent) {
    var activatorCoordinates = getEventCoordinates(activatorEvent);
    if (!activatorCoordinates) {
      return transform;
    }
    var offsetX = activatorCoordinates.x - draggingNodeRect.left;
    var offsetY = activatorCoordinates.y - draggingNodeRect.top;
    return _objectSpread(_objectSpread({}, transform), {}, {
      x: transform.x + offsetX - draggingNodeRect.width / 2,
      y: transform.y + offsetY - draggingNodeRect.height / 2
    });
  }
  return transform;
};
export { createSnapModifier, restrictToFirstScrollableAncestor, restrictToHorizontalAxis, restrictToParentElement, restrictToVerticalAxis, restrictToWindowEdges, snapCenterToCursor };